import { render, staticRenderFns } from "./OperativeTableHeader.vue?vue&type=template&id=f5611880&"
import script from "./OperativeTableHeader.vue?vue&type=script&lang=js&"
export * from "./OperativeTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./OperativeTableHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports